/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

var useViewerScale = function useViewerScale(viewerScale) {
  var result = {
    minWidth: 1e3,
    minHeight: 1e3
  };
  if ((viewerScale === null || viewerScale === void 0 ? void 0 : viewerScale.minWidth) !== void 0) result.minWidth = viewerScale.minWidth;
  if ((viewerScale === null || viewerScale === void 0 ? void 0 : viewerScale.minHeight) !== void 0) result.minHeight = viewerScale.minHeight;
  return result;
};

export { useViewerScale as default };
//# sourceMappingURL=useViewerScale.js.map
